import { render, staticRenderFns } from "./DormantMemberIframe.vue?vue&type=template&id=40e12ca8&"
import script from "./DormantMemberIframe.vue?vue&type=script&lang=ts&"
export * from "./DormantMemberIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports